import React from 'react';
import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { IoClose } from 'react-icons/io5';

/**
 * A "pílula" de um item escolhido num seletor múltiplo, com o botão de remover.
 *
 * POR QUE UM COMPONENTE, e não a `Tag` do Chakra solta em cada lugar
 *   Cinco seletores repetiam o mesmo trio Tag/TagLabel/TagCloseButton com
 *   cores e tamanhos ligeiramente diferentes — a mesma coisa parecia cinco
 *   coisas. Centralizar faz o ajuste visual valer para todos de uma vez, que
 *   foi exatamente o pedido.
 *
 * DECISÕES DE DESENHO
 *   - Fundo claro com borda em vez de bloco chapado: a pílula precisa se
 *     distinguir do campo sem competir com o dado da tela.
 *   - O X só ganha fundo no hover. Antes ele tinha peso visual permanente e,
 *     com dez pílulas, a tela virava uma fileira de "x". A área de clique
 *     continua a mesma — muda só a pintura.
 *   - `title` no texto: nome de empresa ou de questionário estoura o espaço, e
 *     truncar sem deixar o texto inteiro alcançável esconde a informação que a
 *     pílula existe para mostrar.
 */
const TagSelecionada = ({ label, onRemove, isDisabled = false, maxW = '220px' }) => (
  <Flex
    align='center'
    gap='6px'
    bg='#F1F6FE'
    border='1px solid #D3E2FA'
    color='#0B4A8F'
    borderRadius='999px'
    pl='10px'
    pr={onRemove && !isDisabled ? '4px' : '10px'}
    h='26px'
    maxW={maxW}
    transition='border-color 0.15s ease'
    _hover={{ borderColor: '#A9C8F5' }}
  >
    <Tooltip label={label} openDelay={400} hasArrow>
      <Text
        fontSize='12px'
        fontWeight={600}
        noOfLines={1}
        title={typeof label === 'string' ? label : undefined}
      >
        {label}
      </Text>
    </Tooltip>

    {onRemove && !isDisabled && (
      <Box
        as='button'
        type='button'
        aria-label={`Remover ${label}`}
        onClick={onRemove}
        display='flex'
        alignItems='center'
        justifyContent='center'
        boxSize='18px'
        borderRadius='full'
        color='#5B7FB4'
        flexShrink={0}
        transition='background-color 0.15s ease, color 0.15s ease'
        _hover={{ bg: '#D3E2FA', color: '#0B4A8F' }}
        _focusVisible={{ boxShadow: '0 0 0 2px #A9C8F5', outline: 'none' }}
      >
        <IoClose size={13} />
      </Box>
    )}
  </Flex>
);

export default TagSelecionada;
